import { useState, useEffect } from 'react'

// Sound effects hook
// Audio files are CC0 from kenney.nl/assets/ui-audio
// Respects user preference (stored in localStorage as 'nq_sound_enabled')

const cache = {}

function loadSound(src) {
  if (!cache[src]) {
    const audio = new Audio(src)
    audio.preload = 'auto'
    cache[src] = audio
  }
  return cache[src]
}

export function isSoundEnabled() {
  try {
    return localStorage.getItem('nq_sound_enabled') !== 'false'
  } catch {
    return true
  }
}

export function setSoundEnabled(enabled) {
  try {
    localStorage.setItem('nq_sound_enabled', enabled ? 'true' : 'false')
  } catch {}
  // Notify listeners
  window.dispatchEvent(new CustomEvent('nq-sound-changed', { detail: enabled }))
}

export function playSound(name, volume = 1.0) {
  if (!isSoundEnabled()) return
  try {
    const src = `/sounds/${name}.ogg`
    const audio = loadSound(src)
    // Clone for overlapping plays
    const clone = audio.cloneNode()
    clone.volume = Math.min(1, Math.max(0, volume))
    clone.play().catch(() => {}) // Ignore autoplay policy errors
  } catch {}
}

export function useSound() {
  const [enabled, setEnabled] = useState(isSoundEnabled())

  useEffect(() => {
    const handler = (e) => setEnabled(e.detail)
    window.addEventListener('nq-sound-changed', handler)
    return () => window.removeEventListener('nq-sound-changed', handler)
  }, [])

  return {
    enabled,
    toggle: () => setSoundEnabled(!enabled),
    play: playSound,
  }
}
